import React, { Component } from 'react'
import styles from './Modal.css'
import Rx from 'rxjs/Rx'

export default class Modal extends Component {
  componentDidMount () {
    const key$ = Rx.Observable.fromEvent(document, 'keydown')

    const escapeKey$ = key$.filter(e => e.keyCode === 27)
    this.escapeSubscription = escapeKey$.subscribe(this.props.quitModal)

    this.oldBodyScrollTop = window.scrollY
    document.body.style.overflowY = 'scroll';
    document.body.style.position = 'fixed';
    document.body.style.width = '100%';
    document.body.style.top = (-this.oldBodyScrollTop) + 'px'
  }

  componentWillUnmount () {
    this.escapeSubscription.unsubscribe()

    document.body.style.overflow = ''
    document.body.style.position = ''
    document.body.style.width = ''
    document.body.style.top = ''
    window.scrollTo(0, this.oldBodyScrollTop)
  }

  render () {
    return (
      <div className={styles.cont}>
        <div onClick={this.props.quitModal} className={styles.screen}/>
        {this.props.children}
        <div onClick={this.props.quitModal} className={styles.closeButton}/>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/Rist/modules/Modal/index.js